

// ===========================
// ACTIONS
// ===========================
export const SHOW_MODAL = 'SHOW_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const CLOSE_ALL_MODALS = 'CLOSE_ALL_MODALS';
export const SHOW_TOAST = 'SHOW_TOAST';
export const TOGGLE_SIDEMENU = 'TOGGLE_SIDEMENU';
export const SHOW_DROPDOWN = 'SHOW_DROPDOWN';
export const HIDE_DROPDOWN = 'HIDE_DROPDOWN';

// ===========================
// SELECTORS
// ===========================
export const selectUI = state => state.ui;
export const selectUIView = (state, key) => state.ui.views[key];
export const selectModals = state => state.ui.modals;
export const selectToast = state => state.ui.toast;
export const selectSidemenu = state => state.ui.sidemenu;
export const selectDropdown = state => state.ui.dropdown;


// ===========================
// VIEW COMPONENT REDUCERS
// ===========================
// Use this for screens, or other connected components, to use global store state
// For example to store which tab they were on, or a search results and keywords
const UIReducerList = [];
export const addUIViewReducer = (key, reducer) => UIReducerList.push([key, reducer])

const viewsReducer = (state, action, [key, reducer]) => {
  let results = reducer(state.views[key], action);
  if(results === state.views[key])
    return state;

  return { ...state,
    views: { ...state.views, [key]: results }
  }
}



// ===========================
// MODEL
// ===========================
const SPEC = {
  modals: [],
  views: {},
  toast: null,
  dropdown: null,
};

const UIState = {
  spec: SPEC,

  actions: {
    showModal: (modal, props) => dispatch => {
      if(_.isString(modal)) 
        return dispatch({
          type: SHOW_MODAL,
          modalType: modal,
          props,
        });
        
      if(_.isPlainObject(modal))
        return dispatch({
          type: SHOW_MODAL,
          modalComponent: modal,
          props,
        });
    },
    closeModal(modalType) {
      return {
        type: CLOSE_MODAL,
        modalType
      };
    },
    closeAllModals() {
      return {
        type: CLOSE_ALL_MODALS
      };
    },

    showDropdown(id) {
      return {
        type: SHOW_DROPDOWN,
        id,
      }
    },
    hideDropdown(id) {
      return {
        type: SHOW_DROPDOWN,
        id,
      }
    },

    showToast: (options) => {
      let message = _.isString(options) ? options : options.message || null;
      options = _.omit(options, 'message') || {};
      return {
        type: SHOW_TOAST,
        message,
        options
      }
    },
    showSuccessToast: options => UIState.actions.showToast({
      ...(_.isString(options) ? { message: `SUCCESS: ${options}` } : options),
      type: 'success'
    }),
    showErrorToast: options => UIState.actions.showToast({
      ...(_.isString(options) ? { message: `ERROR: ${options}` } : options),
      type: 'error'
    }),
    withToasts: (action, success, error) => async (dispatch) => {
      try {
        let results = await dispatch(action);
        let message = _.isFunction(success) ? success(results) : success;
        if(success)
          dispatch(UIState.actions.showSuccessToast(message))
        return Promise.resolve(results);
      } catch(err) {
        console.log(err);
        let message = _.isFunction(error)
          ? error(err)
          : error ?? err.message ?? _.toString(err);
        dispatch(UIState.actions.showErrorToast(message));
        throw err;
      }
    },
  },
  
  reducer: (state = SPEC, action) => {
    const { type } = action;

    switch(type) {
      
      case CLOSE_MODAL:
        return {...state, 
          modals: action.modalType
            ? _.reject(state.modals, { type: action.modalType })
            : _.drop(1, state.modals)
        };
      
        case CLOSE_ALL_MODALS:
        return { ...state, modals: [] };
      
      case SHOW_MODAL:
        return { ...state,
          modals: [
            ...state.modals,
            { type: action.modalType,
              component: action.modalComponent,
              props: action.props },
          ]
        };
     
      case SHOW_TOAST:
        return {
          ...state,
          toast: {
            message: action.message,
            options: action.options,
          }
        }
      case TOGGLE_SIDEMENU:
        return {
          ...state,
          sidemenu: action.show
        }

      case SHOW_DROPDOWN:
        return {
          ...state,
          dropdown: action.id,
        }
      
      case HIDE_DROPDOWN:
        return {
          ...state,
          dropdown: null,
        }
    }
    return _.reduce(UIReducerList, (s, pair) => viewsReducer(s, action, pair), state);
  },
};
export default UIState;